import { useTiers } from "./Landing";

const Legal = ({ title, children, testid }) => (
  <div className="max-w-3xl mx-auto px-5 py-20 prose-legal" data-testid={testid}>
    <p className="eyebrow">Legal · Policy version 2026-06-v1</p>
    <h1 className="mt-3 text-5xl font-black uppercase">{title}</h1>
    <p className="mt-4">Operated by Buddy Innovations &amp; Technologies ("we", "us") for CricAnalyze.</p>
    {children}
  </div>
);

export function Privacy() {
  return (
    <Legal title="Privacy Policy" testid="privacy-page">
      <h2>What we collect</h2>
      <ul><li>Full name, email address, phone number, age and how you heard about CricAnalyze.</li><li>Referral attribution (which member invited you), verification status, and marketing consent records with timestamps and policy version.</li><li>Basic technical data such as IP address for security, rate limiting and fraud prevention.</li></ul>
      <h2>How we use it</h2>
      <ul><li>To manage your waitlist registration and verify your email with one-time codes.</li><li>To calculate referral rewards and prevent duplicate or fraudulent sign-ups.</li><li>To send essential account emails. Promotional emails are sent only if you opt in.</li></ul>
      <h2>Young players</h2>
      <p>CricAnalyze may be used by players under 18. Minors must have a parent or guardian's permission to join. We collect only what is needed for the waitlist and never publish personal information or individual referral statistics.</p>
      <h2>Sharing &amp; access</h2>
      <p>We don't sell your data. Access is restricted to authorized administrators with role-based permissions; exports and sensitive access are audit-logged. There is no public leaderboard.</p>
      <h2>Retention &amp; your rights</h2>
      <p>Unverified registrations are removed after a limited retention period. You can unsubscribe from promotional emails at any time and request access, correction or deletion of your data by replying to any CricAnalyze email.</p>
      <h2>Security</h2>
      <p>One-time codes are stored only as secure hashes, sessions expire automatically, and credentials are never exposed in the browser.</p>
    </Legal>
  );
}

export function Terms() {
  const tiers = useTiers();
  return (
    <Legal title="Terms & Reward Conditions" testid="terms-page">
      <h2>The waitlist</h2>
      <p>CricAnalyze is in development. Joining the waitlist does not guarantee access by any date and does not enable video uploads. Previews on this site are illustrative.</p>
      <h2>Reward tiers</h2>
      <ul>{tiers.map((t) => <li key={t.key}><strong className="text-white">{t.name}</strong> — {t.threshold} eligible referrals: {t.reward} (duration: {t.duration}).</li>)}</ul>
      <p>Your highest achieved tier determines your reward. Rewards do not stack and separate subscription durations are not combined. If subscriptions are not yet live, rewards are marked unlocked and awaiting redemption at launch. A subscription is only active once it has actually been provisioned.</p>
      <h2>Eligible referrals</h2>
      <ul><li>A new person visits through your valid referral link, completes the waitlist form and verifies their email.</li><li>Duplicate emails or phone numbers, self-referrals, repeated submissions, invalid codes, unverified registrations and fraudulent or automated registrations do not count.</li><li>Each person can be attributed to only one referrer. Link clicks and incomplete registrations don't count.</li><li>Suspicious activity may be held for manual review and may be rejected.</li></ul>
      <h2>Changes</h2>
      <p>We may update reward terms before launch. Material changes will be published here before they apply. We may withdraw rewards obtained through abuse.</p>
    </Legal>
  );
}
